import React from 'react'
import PropTypes from 'prop-types'
import useBreakpoints from 'js/hooks/useBreakpoints'
import convert from 'htmr'

import QuoteMark from './quote.svg?svgr-webpack'

const headingTransform = {
  // eslint-disable-next-line react/prop-types
  p: function RichTextHeading1({ children }) {
    return <h1 className="my-32 type-40 md:my-40 md:type-56">{children}</h1>
  },
}

const fullWidthStyle = {
  left: '50%',
  marginLeft: '-50vw',
  marginRight: '-50vw',
  marginTop: '-40px',
  marginBottom: '-40px',
  maxWidth: '100vw',
  position: 'relative',
  right: '50%',
  width: '100vw',
}

function UserCase({
  quoteMarkPosition,
  backgroundImage,
  desktopGradient,
  heading,
  quote,
  quotee,
}) {
  const { MD, LG } = useBreakpoints()

  return (
    <div className="relative bg-white" style={fullWidthStyle}>
      <div
        className={`
          full-width flex flex-col items-center justify-end object-cover 
          px-20 text-center text-white 
          md:items-start md:justify-center md:px-40 md:text-left  
          lg:px-96 lg:pb-40
        `}
        style={{
          background: `${
            desktopGradient && MD
              ? desktopGradient
              : 'linear-gradient(180deg,rgba(19, 20, 27, 0.4),rgba(19, 20, 27, 0.7))'
          }, url(${
            MD
              ? backgroundImage.responsiveImage.src
              : backgroundImage.mobileImage
          }) center/cover`,
        }}
      >
        <div className="pt-256 md:py-48">
          {heading && (
            <div>{convert(heading, { transform: headingTransform })}</div>
          )}
          <div
            className="mb-24 py-32 italic leading-body type-21 md:mb-12 md:type-24 lg:mb-24 lg:type-32"
            style={{ maxWidth: LG ? '600px' : '375px' }}
          >
            {quote}
          </div>
          <div className="mb-24 leading-body type-21 md:mb-12 md:type-24 lg:mb-24 lg:type-32">
            {quotee}
          </div>
        </div>
        <QuoteMark
          className={`absolute right-0 m-32 ${
            MD && quoteMarkPosition === 'bottom' ? 'bottom-0' : 'top-0'
          }`}
        />
      </div>
    </div>
  )
}

UserCase.propTypes = {
  heading: PropTypes.node,
  quote: PropTypes.node,
  quotee: PropTypes.node,
  quoteMarkPosition: PropTypes.oneOf(['top', 'bottom']),
  backgroundImage: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  mobileBackgroundImage: PropTypes.string,
  desktopGradient: PropTypes.string,
  content: PropTypes.any,
}

export default UserCase
